import React, { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { FaFilePdf } from "react-icons/fa";

const PdfGenerator = ({ inline = false, className = "", fileName = "page-screenshot.pdf" }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleDownloadPdf = async () => {
    setIsGenerating(true);
    
    // Store original opacity values
    const originalBodyOpacity = document.body.style.opacity;
    const elements = Array.from(document.querySelectorAll('*'));
    const originalStyles = elements.map(el => ({
      element: el,
      opacity: el.style.opacity
    }));

    try {
      // Set all elements to opacity 1
      elements.forEach(el => {
        el.style.opacity = '1';
        el.style.transform = 'none'; // Fix for fixed/sticky elements
      });
      
      const element = document.body;
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let position = 0;
      let remainingHeight = imgHeight;

      while (remainingHeight > 0) {
        pdf.addImage(
          imgData,
          "PNG",
          0,
          position,
          imgWidth,
          imgHeight
        );
        
        remainingHeight -= pageHeight;
        position -= pageHeight;
        
        if (remainingHeight > 0) {
          pdf.addPage();
        }
      }

      pdf.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      // Restore original opacity values
      originalStyles.forEach(style => {
        style.element.style.opacity = style.opacity;
      });
      document.body.style.opacity = originalBodyOpacity;
      setIsGenerating(false);
    }
  };

  const iconProps = {
    onClick: handleDownloadPdf,
    title: "Download Page as PDF",
    className,
  };

  return (
    <>
      {isGenerating && (
        <div className="fixed top-28 right-6 z-50 bg-gray-800 text-white px-4 py-2 rounded-md shadow-lg">
          Downloading...
        </div>
      )}
      {inline ? (
        <FaFilePdf size={32} {...iconProps} />
      ) : (
        <button
          {...iconProps}
          className={`fixed bottom-6 right-6 z-50 bg-red-600 hover:bg-red-700 text-white p-3 rounded-full shadow-lg ${className}`}
          disabled={isGenerating}
        >
          <FaFilePdf size={24} />
        </button>
      )}
    </>
  );
};

export default PdfGenerator;